var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShipmentBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 169,
    viewBox: "0 0 221 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M220.801 123.01V126.251L138.906 168.391L79.5973 138.549L55.4258 124.565L148.304 87.9751L219.656 123.601L220.457 123.187C220.572 123.128 220.687 123.068 220.801 123.01Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M220.679 124.565L138.053 165.889L138.048 83.2257L220.679 41.939V124.565Z",
    fill: "#946F47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.053 165.889L55.4263 124.565V41.939L138.053 83.2628V165.889Z",
    fill: "#B19255"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M220.679 41.9392L138.053 83.2524L55.4263 41.8968L138.053 0.625977L220.679 41.9392Z",
    fill: "#BD9C5B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M138.053 83.4485L55.4263 42.1247V41.9392L55.6118 41.8438L138.053 83.0721V83.4485Z",
    fill: "#E0B96C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M138.052 83.4485L220.679 42.1247V41.9392L220.488 41.8438L138.052 83.0721V83.4485Z",
    fill: "#E0CCA4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M138.053 93.4456V83.2578C138.053 83.2578 133.351 115.666 138.053 165.884V152.94C136.235 125.753 137.146 104.975 138.053 93.4456Z",
    fill: "#946F47"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M138.052 161.516V84.8955C137.146 96.4297 136.234 134.329 138.052 161.516Z",
    fill: "#6B4D2C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.1 107.201L88.1736 101.238V58.5356L100.1 64.4989V107.201Z",
    fill: "#F7EECF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1683 58.541L100.089 64.5042L183.511 23.3553L171.59 17.3921L88.1683 58.541Z",
    fill: "#FFF6D6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4455 76.9342L62.598 70.8703L60.1385 57.8784L80.986 63.9424L83.4455 76.9342Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5505 69.5716L65.0469 69.4231L63.4514 60.9951L63.955 61.1435L65.5505 69.5716Z",
    fill: "#2C323D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1383 69.741L65.8838 69.6668L64.2883 61.2388L64.5428 61.313L66.1383 69.741Z",
    fill: "#2C323D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7213 69.911L66.4722 69.8421L64.8767 61.4141L65.1258 61.483L66.7213 69.911Z",
    fill: "#2C323D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3104 70.0857L67.0559 70.0115L65.4604 61.5835L65.7149 61.6577L67.3104 70.0857Z",
    fill: "#2C323D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8934 70.2552L67.6443 70.181L66.0488 61.7529L66.298 61.8271L67.8934 70.2552Z",
    fill: "#2C323D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7358 70.4993L68.227 70.3509L66.6315 61.9229L67.1403 62.0713L68.7358 70.4993Z",
    fill: "#2C323D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M70.999 71.1565L70.7445 71.0823L69.149 62.6543L69.4035 62.7285L70.999 71.1565Z",
    fill: "#2C323D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5827 71.326L71.3283 71.2518L69.7328 62.8237L69.9872 62.8979L71.5827 71.326Z",
    fill: "#2C323D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4255 71.5701L71.9167 71.427L70.3212 62.9937L70.8247 63.1421L72.4255 71.5701Z",
    fill: "#2C323D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5735 70.7429L69.0646 70.5945L67.4691 62.1665L67.978 62.3149L69.5735 70.7429Z",
    fill: "#2C323D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4111 70.9871L69.9075 70.8387L68.312 62.4106L68.8156 62.5591L70.4111 70.9871Z",
    fill: "#2C323D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2626 71.8138L72.7537 71.6707L71.1582 63.2427L71.6671 63.3858L73.2626 71.8138Z",
    fill: "#2C323D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8457 71.9886L73.5966 71.9144L72.0011 63.4863L72.2502 63.5552L73.8457 71.9886Z",
    fill: "#2C323D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4341 72.1585L74.1797 72.0843L72.5842 63.6562L72.8387 63.7305L74.4341 72.1585Z",
    fill: "#2C323D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0172 72.3279L74.7681 72.2537L73.1726 63.8257L73.4217 63.8999L75.0172 72.3279Z",
    fill: "#2C323D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6052 72.4973L75.3507 72.4231L73.7552 63.9951L74.0097 64.0693L75.6052 72.4973Z",
    fill: "#2C323D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4427 72.7415L75.9391 72.5931L74.3436 64.165L74.8472 64.3135L76.4427 72.7415Z",
    fill: "#2C323D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7065 73.3987L78.4521 73.3245L76.8566 64.8965L77.111 64.9707L78.7065 73.3987Z",
    fill: "#2C323D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2949 73.5735L79.0404 73.4993L77.4449 65.0713L77.6994 65.1402L79.2949 73.5735Z",
    fill: "#2C323D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1319 73.8176L79.6231 73.6692L78.0276 65.2412L78.5365 65.3896L80.1319 73.8176Z",
    fill: "#2C323D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2803 72.9851L76.7768 72.8367L75.1813 64.4087L75.6848 64.5571L77.2803 72.9851Z",
    fill: "#2C323D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1233 73.2293L77.6144 73.0809L76.0189 64.6528L76.5278 64.8012L78.1233 73.2293Z",
    fill: "#2C323D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M132.212 99.3506L106.042 86.2633V73.8174L132.212 86.9047V99.3506Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7289 116.737L58.4263 112.083C58.0817 111.908 57.8008 112.051 57.8008 112.395V121.698C57.8008 122.043 58.0817 122.461 58.4263 122.636L67.7289 127.285C68.0734 127.46 68.3544 127.317 68.3544 126.972V117.669C68.3544 117.325 68.0734 116.906 67.7289 116.731V116.737ZM67.8667 126.225C67.8667 126.58 67.5805 126.723 67.2253 126.548L58.9351 122.403C58.58 122.228 58.2937 121.793 58.2937 121.438V113.148C58.2937 112.793 58.58 112.65 58.9351 112.825L67.2253 116.97C67.5805 117.145 67.8667 117.579 67.8667 117.935V126.225Z",
    fill: "#2C323D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3845 122.149L60.7961 121.857V115.47L61.3845 115.767V122.149Z",
    fill: "#2C323D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0926 114.781L60.2922 115.984L61.0926 116.387L61.893 116.784L61.0926 114.781Z",
    fill: "#2C323D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3602 124.136L64.7719 123.845V117.458L65.3602 117.754V124.136Z",
    fill: "#2C323D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0683 116.769L64.2679 117.972L65.0683 118.375L65.8687 118.772L65.0683 116.769Z",
    fill: "#2C323D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4656 122.064V121.476L66.6957 125.091V125.679L59.4656 122.064Z",
    fill: "#2C323D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2385 122.997L70.9359 118.348C70.5914 118.173 70.3104 118.316 70.3104 118.661V127.964C70.3104 128.308 70.5914 128.727 70.9359 128.902L80.2385 133.55C80.5831 133.725 80.864 133.582 80.864 133.238V123.935C80.864 123.591 80.5831 123.172 80.2385 122.997ZM80.3763 132.485C80.3763 132.84 80.0901 132.983 79.735 132.808L71.4448 128.663C71.0896 128.488 70.8034 128.054 70.8034 127.699V119.408C70.8034 119.053 71.0896 118.91 71.4448 119.085L79.735 123.23C80.0901 123.405 80.3763 123.84 80.3763 124.195V132.485Z",
    fill: "#2C323D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7785 127.63C76.994 127.237 76.3579 126.283 76.3579 125.493V122.207L79.2044 123.628V126.914C79.2044 127.698 78.5683 128.017 77.7838 127.624L77.7785 127.63Z",
    fill: "#2C323D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9481 131.012L77.6141 130.847V127.407L77.9481 127.577V131.012Z",
    fill: "#2C323D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3579 130.45C76.3579 130.264 76.5063 130.19 76.6919 130.285L78.8704 131.377C79.0559 131.467 79.2044 131.695 79.2044 131.875L76.3579 130.455V130.45Z",
    fill: "#2C323D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9747 120.018V123.304C71.9747 124.089 72.6107 125.043 73.3952 125.441C74.1797 125.833 74.8158 125.515 74.8158 124.73V121.444L71.9694 120.023L71.9747 120.018ZM74.5296 124.582C74.5296 125.207 74.0207 125.457 73.4005 125.149C72.7751 124.836 72.2715 124.078 72.2715 123.453V120.458L74.5296 121.587V124.582Z",
    fill: "#2C323D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5592 128.817L73.2306 128.653V125.218L73.5592 125.383V128.817Z",
    fill: "#2C323D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9744 128.255C71.9744 128.07 72.1228 127.996 72.3083 128.091L74.4869 129.183C74.6724 129.273 74.8208 129.501 74.8208 129.681L71.9744 128.261V128.255Z",
    fill: "#2C323D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7482 129.251L83.4455 124.603C83.101 124.428 82.8201 124.571 82.8201 124.915V134.218C82.8201 134.563 83.101 134.981 83.4455 135.156L92.7482 139.805C93.0927 139.98 93.3736 139.837 93.3736 139.492V130.189C93.3736 129.845 93.0927 129.426 92.7482 129.251ZM92.886 138.739C92.886 139.095 92.5998 139.238 92.2446 139.063L83.9544 134.918C83.5993 134.743 83.313 134.308 83.313 133.953V125.663C83.313 125.308 83.5993 125.164 83.9544 125.339L92.2446 129.485C92.5998 129.659 92.886 130.094 92.886 130.449V138.739Z",
    fill: "#2C323D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2069 131.054C86.4773 130.953 86.8271 130.99 87.2141 131.181C87.601 131.372 87.9509 131.69 88.2212 132.061C88.4915 131.96 88.8414 131.997 89.2283 132.188C89.6153 132.379 89.9651 132.697 90.2354 133.068C90.5058 132.967 90.8556 133.004 91.2426 133.195C91.3274 133.237 91.4069 133.285 91.4917 133.338C91.3433 131.605 89.9545 129.607 88.2583 128.758C86.5621 127.91 85.1733 128.515 85.0249 130.089C85.0832 130.11 85.1415 130.137 85.1998 130.168C85.5868 130.359 85.9366 130.677 86.2069 131.048V131.054Z",
    fill: "#2C323D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5688 136.184C87.0918 135.946 86.7048 135.363 86.7048 134.886V134.722C86.7048 134.621 86.7843 134.584 86.8851 134.631C86.9858 134.679 87.0653 134.801 87.0653 134.896V135.061C87.0653 135.342 87.2932 135.686 87.5741 135.824C87.8551 135.967 88.083 135.851 88.083 135.57V128.361C88.083 128.26 88.1625 128.223 88.2632 128.271C88.3639 128.318 88.4434 128.44 88.4434 128.536V135.745C88.4434 136.222 88.0565 136.418 87.5794 136.179L87.5688 136.184Z",
    fill: "#2C323D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M142.389 9.75909L120.396 20.7526L119.713 20.4081L141.7 9.41455L142.389 9.75909Z",
    fill: "#2C323D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M144.546 10.8353L122.559 21.8289L121.87 21.4896L143.862 10.4961L144.546 10.8353Z",
    fill: "#2C323D"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M146.703 11.9163L124.716 22.9099L124.027 22.5653L146.019 11.5718L146.703 11.9163Z",
    fill: "#2C323D"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M148.861 12.9926L126.874 23.9914L126.19 23.6469L148.177 12.6533L148.861 12.9926Z",
    fill: "#2C323D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M146.152 59.2669L124.165 70.2604L123.481 69.9159L145.468 58.9224L146.152 59.2669Z",
    fill: "#2C323D"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M148.309 60.3432L126.322 71.3367L125.638 70.9974L147.625 60.0039L148.309 60.3432Z",
    fill: "#2C323D"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M150.467 61.4241L128.48 72.4177L127.796 72.0731L149.783 61.0796L150.467 61.4241Z",
    fill: "#2C323D"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M152.624 62.5004L130.637 73.4992L129.953 73.1547L151.94 62.1611L152.624 62.5004Z",
    fill: "#2C323D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M118.038 32.9971L175.703 64.6154V78.4183C175.703 79.3141 176.647 79.8918 177.442 79.4943L210.905 62.9086C211.673 62.5216 212.161 61.7319 212.161 60.8731V46.6674L118.032 33.0024L118.038 32.9971Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M93.5183 167.319L135.31 160.92L159.578 127.488L137.575 116.243L93.5183 167.319Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M2.17456 105.688L45.0531 143.041L63.7953 115.298L2.17456 105.688Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M135.31 160.92L82.3442 148.72L124.441 143.041L135.31 160.92Z",
    fill: "url(#paint0_linear_78_444)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M0.559204 99.2178L134.061 135.402L157.374 117.097L138.612 100.508L0.559204 99.2178Z",
    fill: "#FAFAFA"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M0.559204 99.2178L124.441 143.041L93.5185 167.32L65.0446 162.738L0.559204 99.2178Z",
    fill: "#FAFAFA"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M73.6694 125.081L65.0449 162.738L71.2212 163.724L77.8039 126.544L73.6694 125.081Z",
    fill: "url(#paint1_linear_78_444)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M134.061 135.402L135.31 160.92L124.441 143.041L0.559204 99.2178L134.061 135.402Z",
    fill: "url(#paint2_linear_78_444)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_78_444",
    x1: 132.554,
    y1: 165.129,
    x2: 90.0519,
    y2: 137.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#858585"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_78_444",
    x1: 75.6145,
    y1: 145.409,
    x2: 69.2045,
    y2: 143.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_78_444",
    x1: 130.375,
    y1: 117.307,
    x2: 9.34907,
    y2: 142.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B8B8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipmentBox);
export default __webpack_public_path__ + "static/media/shipmentBox.832d11252993134bea0939016150020a.svg";
export { ForwardRef as ReactComponent };